import Supporter from "@/utils/supporter";

/**
 * 
 * @param {number} pxNum px数
 * @returns 转换后的rem数
 */
export const pxToRem = (pxNum) => {
    const standardViewWidth = 375
    const viewWidth = window.innerWidth
    const baseSize = document.documentElement.style.fontSize.replace("px", "")
    const baseSizeNum = Number(baseSize)
    const result = (pxNum/standardViewWidth)*viewWidth/baseSizeNum
    return result
}

/**
 * @description 获取中插广告插入位置前的DOM
 * @param {*} articleDom 
 * @returns 
 */
export const getMiddleInsertBeforeDom = function(articleDom = document.querySelector("#articleContent")){
    var array = []; //文章节点数组，用来计算中插广告插入位置
    if (articleDom && articleDom.firstElementChild) {
        //获取所有文章页节点
        var _displayContent = articleDom.querySelector(".display-content");
        var _hiddenContent = articleDom.querySelector(".hidden-content");
        if (_displayContent) {
            array = array.concat.apply(array, _displayContent.children);
        }
        if (_hiddenContent) {
            array = array.concat.apply(array, _hiddenContent.children);
        }
    }

    var failCallback = function () {};

    /**
     * 获取dom的非空兄弟节点
     * @param _dom
     * @returns {*}
     * @private
     */
    function GetNextElement(_dom) {
        if (_dom) {
            _dom = _dom.nextElementSibling;
            while (_dom) {
                if (!CheckIsEmpty(_dom)) {
                    return _dom;
                }
                _dom = _dom.nextElementSibling;
            }
        }
        return null;
    }

    /**
     * 检测dom是否为空标签
     * @param _dom
     * @returns {boolean}
     */
    function CheckIsEmpty(_dom) {
        var _sHtml = _dom.innerHTML.trim();
        return (
            _dom.tagName === "P" &&
            (!_sHtml || !_sHtml.replace(/&nbsp;|\s/g, ""))
        );
    }

    /**
     * 检测dom是否为标题，规则：p且只含非空strong不含其它非空标签
     * @param _dom
     * @returns {boolean}
     */
    function CheckIsStrong(_dom) {
        if (_dom && _dom.tagName === "P") {
            var _html = _dom.innerHTML;
            _html = _html.replace(/\s/g, "");
            var _oStrongReg = /<strong>[^\s]*?<\/strong>/g;
            var _oNullReg = /<([^>]+)>\s*<\/\1>/g;
            if (_oStrongReg.test(_html)) {
                while (!!_html && _oNullReg.test(_html)) {
                    //替换所有空标签如<a></a>
                    _html = _html.replace(_oNullReg, "");
                }
                _html = _html.replace(_oStrongReg, ""); //替换所有非空strong，若仍有内容，则表示有strong外的内容，则不为标题
                return !_html;
            }
        }
        return false;
    }

    /**
     * 检测dom是否为媒体元素
     * 图片：p[style=’text-align:center’] 且含<img>   || <div class="pic"><img></div>
     * 视频： <div id=“replace_video_?" class="place_video”>
     * 2017-06-13更新
     * @param _dom
     * @returns {boolean}
     */
    function CheckIsMedia(_dom) {
        if (_dom) {
            var _oReg = /<img[^>]*?>/;
            var _oIdReg = /^replace_video_/;
            if (_oReg.test(_dom.outerHTML)) {
                //图片
                return true;
            }
            if (
                _dom.tagName === "DIV" &&
                _oIdReg.test(_dom.id) &&
                _dom.classList.contains("place_video")
            ) {
                return true;
            }
        }
        return false;
    }

    /**
     * 是否需过滤
     * @param _dom
     * @returns {*|boolean}
     * @private
     */
    function CheckNeedFilter(_dom) {
        return (
            CheckIsEmpty(_dom) ||
            _dom.id === "artLookAll" ||
            _dom.classList.contains("statement")
        );
    }

    /**
     * 获取文章段落dom，此段落dom之后需要插入广告或者空广告
     * 2018-06-4更新
     * @returns {object} dom
     */
    function getInsertAfterDom() {
        var ia = 0; //段落计数
        var _nIndex = 0; //有效段落计数
        var _bInserted = false; //是否插入完毕
        var oDom = null;
        const _referer = document.referrer;
        const isFromSearch = (_referer && (_referer.match(/baidu/g) || _referer.match(/sogou/g))) || Supporter.isBaiduboxapp;

        //百度中插广告默认文章声明或阅读数之前插入s
        //是否为搜索来源判断逻辑外移或者在手机百度app内
        if (isFromSearch) {
            var oDom = document.querySelector("article");
            _bInserted = true;
        }

        while (ia < array.length && !_bInserted) {
            var _p = array[ia];
            var _bNeedFilter = CheckNeedFilter(_p);
            if (_nIndex >= 2 && !_bNeedFilter && !CheckIsStrong(_p)) {
                var _bIsMedia = CheckIsMedia(_p);

                //插在文章段落或最后一个媒体内容后
                if (
                    !_bIsMedia ||
                    (_bIsMedia && !CheckIsMedia(GetNextElement(_p)))
                ) {
                    oDom = _p;
                    _bInserted = true;
                    break;
                }
            }

            //过滤情况，空标签／查看全文／声明
            if (!_bNeedFilter) {
                _nIndex++;
            }
            ia++;
        }

        //未插入，说明段落数<=3或没满足条件的，插在文章底部
        if (!_bInserted) {
            var _parent = _hiddenContent || _displayContent;
            if (_parent) {
                oDom = _parent.lastElementChild;
            }
        }

        return oDom;
    }
    return getInsertAfterDom()
}